import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { GroupRightsComponent }       from './group-rights.component';
import { GroupRightsGroupsComponent } from './group-rights.groups.component';
import { GroupRightsService }         from './group-rights.service';
import { GroupRightsStates }          from './group-rights.states';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    GroupRightsComponent,
    GroupRightsGroupsComponent
  ],
  entryComponents: [
    GroupRightsComponent,
    GroupRightsGroupsComponent
  ],
  imports: [
    SharedModule,

    UIRouterModule.forChild({ states: GroupRightsStates })
  ],
  providers: [
    GroupRightsService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class GroupsRightsModule {}
